import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X, ZoomIn } from 'lucide-react';

/* =========================================
   PENGATURAN KATEGORI & DATA FOTO
   Sangat gampang untuk copy-paste/tambah foto!
========================================= */
const GALLERY_CATEGORIES = [
  { key: 'all',        label_id: 'Semua',        label_en: 'All',           label_zh: '全部' },
  { key: 'exterior',   label_id: 'Eksterior',    label_en: 'Exterior',      label_zh: '外观' },
  { key: 'rooms',      label_id: 'Kamar',        label_en: 'Rooms',         label_zh: '客房' },
  { key: 'pool',       label_id: 'Kolam Renang', label_en: 'Swimming Pool', label_zh: '游泳池' },
  { key: 'garden',     label_id: 'Taman',        label_en: 'Garden',        label_zh: '花园' },
  { key: 'restaurant', label_id: 'Restoran',     label_en: 'Restaurant',    label_zh: '餐厅' },
];

const GALLERY_PHOTOS = [
{ id: 1, category: 'restaurant', src: '/images/tempat makan1.jpg', title_id: 'Area Makan', title_en: 'Dining Area', title_zh: '餐饮区' },
{ id: 2, category: 'exterior', src: '/images/RECEPCIONIS 1.jpg', title_id: 'Resepsionis', title_en: 'Reception', title_zh: '前台' },
{ id: 3, category: 'exterior', src: '/images/RECEPCIONIS.jpg', title_id: 'Resepsionis', title_en: 'Reception', title_zh: '前台' },
{ id: 4, category: 'rooms', src: '/images/SRITANJUNG (1).jpg', title_id: 'Kamar Sri Tanjung', title_en: 'Sri Tanjung Room', title_zh: '斯里坦珠客房' },
{ id: 5, category: 'rooms', src: '/images/SRITANJUNG (2).jpg', title_id: 'Kamar Sri Tanjung', title_en: 'Sri Tanjung Room', title_zh: '斯里坦珠客房' },
{ id: 6, category: 'rooms', src: '/images/SRITANJUNG (3).jpg', title_id: 'Kamar Sri Tanjung', title_en: 'Sri Tanjung Room', title_zh: '斯里坦珠客房' },
{ id: 7, category: 'rooms', src: '/images/SRITANJUNG (4).jpg', title_id: 'Kamar Sri Tanjung', title_en: 'Sri Tanjung Room', title_zh: '斯里坦珠客房' },
{ id: 8, category: 'rooms', src: '/images/SRITANJUNG (5).jpg', title_id: 'Kamar Sri Tanjung', title_en: 'Sri Tanjung Room', title_zh: '斯里坦珠客房' },
{ id: 9, category: 'rooms', src: '/images/SRITANJUNG (6).jpg', title_id: 'Kamar Mandi Sri Tanjung', title_en: 'Sri Tanjung Bathroom', title_zh: '斯里坦珠卫生间' },
{ id: 10, category: 'garden', src: '/images/VIEW HALAMAN (1).JPG', title_id: 'Taman Malam', title_en: 'Garden at Night', title_zh: '夜晚花园' },
{ id: 11, category: 'garden', src: '/images/VIEW HALAMAN (9).JPG', title_id: 'Tampak Samping Kolam', title_en: 'Pool Side View', title_zh: '泳池侧景' },
{ id: 12, category: 'garden', src: '/images/VIEW HALAMAN (10).JPG', title_id: 'Tampak Depan Kamar', title_en: 'Room Front View', title_zh: '客房正面' },
{ id: 13, category: 'garden', src: '/images/VIEW HALAMAN (11).JPG', title_id: 'Taman Malam', title_en: 'Night Garden', title_zh: '夜晚庭院' },
{ id: 14, category: 'garden', src: '/images/VIEW HALAMAN (12).JPG', title_id: 'Taman dengan Hammock', title_en: 'Garden with Hammock', title_zh: '吊床花园' },
{ id: 15, category: 'garden', src: '/images/VIEW HALAMAN (13).JPG', title_id: 'Taman dengan Hammock', title_en: 'Garden with Hammock', title_zh: '吊床花园' },
{ id: 16, category: 'garden', src: '/images/VIEW HALAMAN (14).JPG', title_id: 'Taman dengan Air Mancur', title_en: 'Garden with Fountain', title_zh: '喷泉花园' },
{ id: 17, category: 'garden', src: '/images/VIEW HALAMAN (15).JPG', title_id: 'Taman Depan', title_en: 'Front Garden', title_zh: '前庭花园' },
{ id: 18, category: 'garden', src: '/images/VIEW HALAMAN (16).JPG', title_id: 'Taman Depan', title_en: 'Front Garden', title_zh: '前庭花园' },
{ id: 19, category: 'exterior', src: '/images/VIEW HALAMAN (17).JPG', title_id: 'Tampak Depan', title_en: 'Front View', title_zh: '正面外观' },
{ id: 20, category: 'restaurant', src: '/images/tempat makan_1.jpg', title_id: 'Ruang Makan', title_en: 'Restaurant', title_zh: '餐厅' },
{ id: 21, category: 'rooms', src: '/images/Kamar Sukamade (4).jpg', title_id: 'Kamar Sukamade - Area TV', title_en: 'Sukamade Room - TV Area', title_zh: 'Sukamade客房 - 电视区' },
{ id: 22, category: 'rooms', src: '/images/Kamar Sukamade (5).jpg', title_id: 'Kamar Sukamade - Lemari & Pintu', title_en: 'Sukamade Room - Wardrobe & Door', title_zh: 'Sukamade客房 - 衣柜与门口' },
{ id: 23, category: 'rooms', src: '/images/Kamar Sukamade (6).jpg', title_id: 'Kamar Sukamade - Kamar Mandi', title_en: 'Sukamade Room - Bathroom', title_zh: 'Sukamade客房 - 浴室' },
{ id: 24, category: 'rooms', src: '/images/Kamar Sukamade (7).jpg', title_id: 'Kamar Sukamade - Tempat Tidur', title_en: 'Sukamade Room - Bed View', title_zh: 'Sukamade客房 - 床铺view' },
{ id: 25, category: 'rooms', src: '/images/KAWAH IJEN (1).jpg', title_id: 'Pintu Masuk Kamar Kawah Ijen', title_en: 'Kawah Ijen Room Entrance', title_zh: 'Kawah Ijen客房入口' },
{ id: 26, category: 'rooms', src: '/images/KAWAH IJEN (2).jpg', title_id: 'Kamar Kawah Ijen - Twin Bed', title_en: 'Kawah Ijen Room - Twin Bed', title_zh: 'Kawah Ijen客房 - 双床房' },
{ id: 27, category: 'rooms', src: '/images/KAWAH IJEN (3).jpg', title_id: 'Kamar Kawah Ijen - Twin Bed & Lemari', title_en: 'Kawah Ijen Room - Twin Bed & Wardrobe', title_zh: 'Kawah Ijen客房 - 双床与衣柜' },
{ id: 28, category: 'rooms', src: '/images/KAWAH IJEN (4).jpg', title_id: 'Kamar Kawah Ijen - Area Kerja', title_en: 'Kawah Ijen Room - Work Desk Area', title_zh: 'Kawah Ijen客房 - 办公区' },
{ id: 29, category: 'rooms', src: '/images/KAWAH IJEN (5).jpg', title_id: 'Kamar Mandi Kawah Ijen', title_en: 'Kawah Ijen Bathroom', title_zh: 'Kawah Ijen浴室' },
{ id: 30, category: 'pool', src: '/images/KOLAM RENANG 1.jpg', title_id: 'Kolam Renang - Malam Hari', title_en: 'Swimming Pool - Night View', title_zh: '游泳池 - 夜景' },
{ id: 31, category: 'pool', src: '/images/KOLAM RENANG 2.jpg', title_id: 'Kolam Renang - Tampak Dekat', title_en: 'Swimming Pool - Close View', title_zh: '游泳池 - 近景' },
{ id: 32, category: 'pool', src: '/images/KOLAM RENANG.jpg', title_id: 'Kolam Renang - Area Bersantai', title_en: 'Swimming Pool - Lounge Area', title_zh: '游泳池 - 休闲区' },
{ id: 33, category: 'rooms', src: '/images/MINAKJINGGO (1).jpg', title_id: 'Kamar Minakjinggo - Area Makan', title_en: 'Minakjinggo Room - Dining Area', title_zh: 'Minakjinggo客房 - 用餐区' },
{ id: 34, category: 'rooms', src: '/images/MINAKJINGGO (2).jpg', title_id: 'Kamar Minakjinggo - Ruang Tamu', title_en: 'Minakjinggo Room - Living Area', title_zh: 'Minakjinggo客房 - 客厅区' },
{ id: 35, category: 'rooms', src: '/images/MINAKJINGGO (3).jpg', title_id: 'Kamar Minakjinggo - Twin Bed & Sofa', title_en: 'Minakjinggo Room - Twin Bed & Sofa', title_zh: 'Minakjinggo客房 - 双床与沙发' },
{ id: 36, category: 'rooms', src: '/images/MINAKJINGGO (4).jpg', title_id: 'Kamar Minakjinggo - Lemari & Pintu', title_en: 'Minakjinggo Room - Wardrobe & Door', title_zh: 'Minakjinggo客房 - 衣柜与门' },
{ id: 37, category: 'rooms', src: '/images/MINAKJINGGO (5).jpg', title_id: 'Kamar Minakjinggo - Area Santai', title_en: 'Minakjinggo Room - Lounge Corner', title_zh: 'Minakjinggo客房 - 休闲角' },
{ id: 38, category: 'rooms', src: '/images/MINAKJINGGO (6).jpg', title_id: 'Kamar Minakjinggo - Tampak Keseluruhan', title_en: 'Minakjinggo Room - Full View', title_zh: 'Minakjinggo客房 - 全景' },
{ id: 39, category: 'rooms', src: '/images/MINAKJINGGO (7).jpg', title_id: 'Kamar Mandi Minakjinggo', title_en: 'Minakjinggo Bathroom', title_zh: 'Minakjinggo浴室' },
{ id: 40, category: 'exterior', src: '/images/MINAKJINGGO (8).jpg', title_id: 'Tampak Depan Kamar Minakjinggo', title_en: 'Minakjinggo Room - Front View', title_zh: 'Minakjinggo客房 - 外观' },
{ id: 41, category: 'rooms', src: '/images/Bengalow-JOGOPATI DAN AGUNG WILIS (1).jpg', title_id: 'Teras Bungalow Jogopati & Agung Wilis', title_en: 'Jogopati & Agung Wilis Bungalow Terrace', title_zh: '茹格帕蒂与阿贡威利斯小屋露台' },
{ id: 42, category: 'rooms', src: '/images/Bengalow-JOGOPATI DAN AGUNG WILIS (2).jpg', title_id: 'Kamar Bungalow Jogopati & Agung Wilis', title_en: 'Jogopati & Agung Wilis Bungalow Room', title_zh: '茹格帕蒂与阿贡威利斯小屋客房' },
{ id: 43, category: 'rooms', src: '/images/Bengalow-JOGOPATI DAN AGUNG WILIS (3).jpg', title_id: 'Kamar Mandi Bungalow Jogopati & Agung Wilis', title_en: 'Jogopati & Agung Wilis Bungalow Bathroom', title_zh: '茹格帕蒂与阿贡威利斯小屋卫生间' },
{ id: 44, category: 'rooms', src: '/images/Bengalow-JOGOPATI DAN AGUNG WILIS (4).jpg', title_id: 'Kamar Tidur Bungalow Jogopati & Agung Wilis', title_en: 'Jogopati & Agung Wilis Bungalow Bedroom', title_zh: '茹格帕蒂与阿贡威利斯小屋卧室' },
{ id: 45, category: 'rooms', src: '/images/Bengalow-JOGOPATI DAN AGUNG WILIS (5).jpg', title_id: 'Tampak Depan Bungalow Jogopati & Agung Wilis', title_en: 'Jogopati & Agung Wilis Bungalow Front View', title_zh: '茹格帕蒂与阿贡威利斯小屋正面' },
{ id: 46, category: 'rooms', src: '/images/Kamar Bangsring (1).jpg', title_id: 'Tampak Depan Kamar Bangsring', title_en: 'Bangsring Room Front View', title_zh: '班斯令客房正面' },
{ id: 47, category: 'rooms', src: '/images/Kamar Bangsring (2).jpg', title_id: 'Kamar Bangsring', title_en: 'Bangsring Room', title_zh: '班斯令客房' },
{ id: 48, category: 'rooms', src: '/images/Kamar Bangsring (3).jpg', title_id: 'Ruang Santai Kamar Bangsring', title_en: 'Bangsring Room Lounge Area', title_zh: '班斯令客房休息区' },
{ id: 49, category: 'rooms', src: '/images/Kamar Bangsring (4).jpg', title_id: 'Meja Kerja Kamar Bangsring', title_en: 'Bangsring Room Work Desk', title_zh: '班斯令客房书桌' },
{ id: 50, category: 'rooms', src: '/images/Kamar Bangsring (5).jpg', title_id: 'Kamar Bangsring', title_en: 'Bangsring Room', title_zh: '班斯令客房' },
{ id: 51, category: 'rooms', src: '/images/Kamar Sukamade (1).jpg', title_id: 'Tampak Depan Kamar Sukamade', title_en: 'Sukamade Room Front View', title_zh: '苏卡玛德客房正面' },
{ id: 52, category: 'rooms', src: '/images/Kamar Sukamade (2).jpg', title_id: 'Kamar Sukamade', title_en: 'Sukamade Room', title_zh: '苏卡玛德客房' },
{ id: 53, category: 'rooms', src: '/images/Kamar Sukamade (3).jpg', title_id: 'Kamar Sukamade', title_en: 'Sukamade Room', title_zh: '苏卡玛德客房' },
  // Tambahkan baris baru di sini jika ada foto tambahan. Pastikan 'category' sesuai dengan 'key' di atas.
];

export default function Gallery() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'id';
  
  const [filterCat, setFilterCat] = useState('all');
  const [selectedImg, setSelectedImg] = useState(null);

  // Filter logika
  const filteredPhotos = filterCat === 'all' 
    ? GALLERY_PHOTOS 
    : GALLERY_PHOTOS.filter(p => p.category === filterCat);

  return (
    <div className="bg-[#FAF8F5] min-h-screen pt-32 pb-20 px-6">
      
      {/* HEADER & FILTER */}
      <div className="max-w-6xl mx-auto text-center mb-12">
        <h1 className="font-display text-4xl lg:text-5xl font-bold text-amber-900 mb-4">
          {lang === 'zh' ? '图库' : (lang === 'en' ? 'Our Gallery' : 'Galeri Properti')}
        </h1>
        <p className="text-slate-600 max-w-2xl mx-auto mb-8 font-sans">
          {lang === 'zh' 
            ? '探索我们美丽的住宿体验。' 
            : (lang === 'en' 
                ? 'Discover the beauty of Ndalem Mataram through our visual collection.' 
                : 'Jelajahi keindahan dan kenyamanan properti kami melalui koleksi visual ini.')}
        </p>
        
        <div className="flex justify-center gap-3 flex-wrap">
          {GALLERY_CATEGORIES.map(cat => (
            <button
              key={cat.key}
              onClick={() => setFilterCat(cat.key)}
              className={`px-5 py-2.5 rounded-full text-sm font-sans font-medium transition-all duration-300 ${
                filterCat === cat.key 
                  ? 'bg-amber-800 text-white shadow-md shadow-amber-900/20' 
                  : 'bg-white border border-gray-200 text-slate-600 hover:border-amber-600 hover:text-amber-700'
              }`}
            >
              {lang === 'zh' ? cat.label_zh : (lang === 'en' ? cat.label_en : cat.label_id)}
            </button>
          ))}
        </div>
      </div>

      {/* MASONRY GRID LAYOUT */}
      <div className="max-w-6xl mx-auto columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
        {filteredPhotos.map(photo => (
          <div 
            key={photo.id} 
            className="break-inside-avoid relative rounded-2xl overflow-hidden group cursor-pointer shadow-sm hover:shadow-xl transition-all duration-500 bg-white"
            onClick={() => setSelectedImg(photo)}
          >
            {/* Fallback ukuran jika gambar gagal load atau sedang dimuat */}
            <div className="bg-gray-100 flex items-center justify-center min-h-[250px]">
              <img 
                src={photo.src} 
                alt={photo.title_id} 
                className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700" 
                loading="lazy"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentNode.innerHTML = '<span class="text-gray-400 text-sm">Gambar tidak ditemukan</span>';
                }}
              />
            </div>

            {/* Overlay Gelap Elegan saat di-hover */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
              <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                <p className="text-white font-sans font-bold text-lg mb-1">
                  {lang === 'zh' ? photo.title_zh : (lang === 'en' ? photo.title_en : photo.title_id)}
                </p>
                <div className="flex items-center gap-2 text-amber-300 text-sm font-medium">
                  <ZoomIn size={16} />
                  <span>{lang === 'zh' ? '放大' : (lang === 'en' ? 'View Full' : 'Lihat Penuh')}</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Tampilan Jika Kategori Kosong (Tidak ada foto di kategori tsb) */}
      {filteredPhotos.length === 0 && (
        <div className="text-center py-20 text-slate-500 font-sans">
          <p>{lang === 'en' ? 'No photos available in this category.' : 'Belum ada foto untuk kategori ini.'}</p>
        </div>
      )}

      {/* LIGHTBOX / MODAL FULLSCREEN */}
      {selectedImg && (
        <div className="fixed inset-0 z-[200] bg-black/95 backdrop-blur-sm flex items-center justify-center p-4 sm:p-8 animate-in fade-in duration-200">
          <button 
            onClick={() => setSelectedImg(null)}
            className="absolute top-6 right-6 text-white/70 hover:text-white bg-white/10 hover:bg-white/20 p-2.5 rounded-full transition-colors z-[210]"
            aria-label="Close"
          >
            <X size={24} />
          </button>
          
          <div className="max-w-5xl w-full relative">
            <img 
              src={selectedImg.src} 
              alt={selectedImg.title_id} 
              className="w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
            />
            <p className="text-center text-white text-xl font-display tracking-wide mt-6">
              {lang === 'zh' ? selectedImg.title_zh : (lang === 'en' ? selectedImg.title_en : selectedImg.title_id)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}